@if (!router.url.includes('login')) {
    <app-header (menuToggled)="isMenuOpen = $event"></app-header>
}
<app-side-bar [isMenuOpen]="isMenuOpen"></app-side-bar>

<div>
  <router-outlet></router-outlet>
</div>